import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "centered-container" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { class: "md-body-1" }
const _hoisted_4 = { class: "form" }
const _hoisted_5 = { class: "actions md-layout md-alignment-center-space-between" }
const _hoisted_6 = {
  key: 0,
  class: "loading-overlay"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notifications = _resolveComponent("notifications")!
  const _component_md_input = _resolveComponent("md-input")!
  const _component_md_field = _resolveComponent("md-field")!
  const _component_md_progress_spinner = _resolveComponent("md-progress-spinner")!
  const _component_md_content = _resolveComponent("md-content")!
  const _component_md_snackbar = _resolveComponent("md-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_notifications),
    _createVNode(_component_md_content, { class: "md-elevation-3" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _cache[5] || (_cache[5] = _createElementVNode("img", { src: "https://vuematerial.io/assets/logo-color.png" }, null, -1)),
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "md-title" }, "LEAN PATH", -1)),
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('新しいパスワードを設定してください')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_md_field, null, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('メールアドレス')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.email,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.email) = $event))
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          }),
          _createVNode(_component_md_field, { "md-has-password": "" }, {
            default: _withCtx(() => [
              _createElementVNode("label", null, _toDisplayString(_ctx.$t('新しいパスワード')), 1),
              _createVNode(_component_md_input, {
                modelValue: _ctx.state.newPassword,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.newPassword) = $event)),
                type: "password"
              }, null, 8, ["modelValue"])
            ], undefined, true),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "md-raised md-default",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.cancelAction && _ctx.cancelAction(...args)))
          }, _toDisplayString(_ctx.$t('キャンセル')), 1),
          _createElementVNode("button", {
            class: "md-raised md-primary",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, _toDisplayString(_ctx.$t('設定')), 1)
        ]),
        (_ctx.state.loading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createVNode(_component_md_progress_spinner, {
                "md-mode": "indeterminate",
                "md-stroke": 2
              })
            ]))
          : _createCommentVNode("", true)
      ], undefined, true),
      _: 1
    }),
    _createVNode(_component_md_snackbar, {
      "md-active": _ctx.state.showSnackbar,
      "onUpdate:mdActive": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.showSnackbar) = $event)),
      "md-position": "center",
      "md-duration": 1000,
      "md-persistent": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, _toDisplayString(_ctx.state.snackMessage), 1)
      ], undefined, true),
      _: 1
    }, 8, ["md-active"]),
    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "background" }, null, -1))
  ]))
}